import { NgModule, ModuleWithProviders } from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {RouterModule} from '@angular/router';

import {AppMaterialModule} from '../material.module';


@NgModule({
    imports: [
        AppMaterialModule,
        CommonModule,
        FlexLayoutModule,
        RouterModule
    ],
    exports: [
        AppMaterialModule,
        CommonModule,
        FlexLayoutModule,
        RouterModule
    ]
})
export class SharedModule {

}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/shared/shared.module.ts